import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ExclamationIcon } from '@heroicons/react/solid';

const ConsentModal = ({ show, onHide, onAccept }) => {
  const { t, i18n } = useTranslation();
  const [consentChecked, setConsentChecked] = useState(false);
  const [error, setError] = useState(false);
  
  const termsLink = i18n.language === 'pl' ? '/documents/terms_pl.pdf' : '/documents/terms_en.pdf';

  const handleAccept = () => {
    if (!consentChecked) {
      setError(true);
      return;
    }
    setError(false);
    onAccept();
  };

  const handleClose = () => {
    setConsentChecked(false);
    setError(false);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size='lg'>
      <Modal.Header closeButton className='border-bottom'>
        <Modal.Title className='d-flex align-items-center'>
          <ExclamationIcon className='icon icon-sm text-warning me-2' />
          {t('shared-access.consent.title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant='warning' className='mb-4'>
          <Alert.Heading>{t('shared-access.consent.warning-title')}</Alert.Heading>
          <p className='mb-0'>{t('shared-access.consent.warning-message')}</p>
        </Alert>

        <div className='mb-4'>
          <h6 className='mb-3'>{t('shared-access.consent.how-it-works-title')}</h6>
          <ul className='mb-0'>
            <li>{t('shared-access.consent.how-it-works-1')}</li>
            <li>{t('shared-access.consent.how-it-works-2')}</li>
            <li>{t('shared-access.consent.how-it-works-3')}</li>
            <li>{t('shared-access.consent.how-it-works-4')}</li>
            <li>{t('shared-access.consent.how-it-works-5')}</li>
          </ul>
        </div>

        <div className='mb-3'>
          <h6 className='mb-2'>{t('shared-access.consent.important-title')}</h6>
          <ul className='mb-0'>
            <li>{t('shared-access.consent.important-1')}</li>
            <li>{t('shared-access.consent.important-2')}</li>
            <li>{t('shared-access.consent.important-3')}</li>
            <li>{t('shared-access.consent.important-4')}</li>
          </ul>
        </div>

        <Form.Group className='mb-0'>
          <Form.Check
            type='checkbox'
            id='consent-checkbox'
            checked={consentChecked}
            onChange={(e) => {
              setConsentChecked(e.target.checked);
              setError(false);
            }}
            isInvalid={error}
            label={
              <span>
                {t('shared-access.consent.checkbox-label')}{' '}
                <a href={termsLink} target='_blank' rel='noopener noreferrer'>
                  {t('shared-access.consent.terms-link')}
                </a>
              </span>
            }
          />
          {error && (
            <Form.Control.Feedback type='invalid' className='d-block'>
              {t('shared-access.consent.checkbox-error')}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose}>
          {t('shared-access.consent.cancel')}
        </Button>
        <Button variant='primary' onClick={handleAccept} disabled={!consentChecked}>
          {t('shared-access.consent.accept')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConsentModal;

